import * as React from 'react';
import createSvgIcon from '../../utils/createSvgIcon';

const CheckboxUnchecked = createSvgIcon(
  <path d="M21.6 2.4V21.6H2.4V2.4H21.6ZM0 0V24H24V0H0Z" />,
  'CheckboxUnchecked'
);

export { CheckboxUnchecked };